export default __webpack_public_path__ + "static/media/travel-care-5.306136b2.svg";